import { TypeSource } from 'views/Conversation/Sider/ToDoBundle/NewTodo';
import { Panel } from '../Panel';
import { useTranslate } from '@tolgee/react';
import { useEffect, useMemo } from 'react';
import { Radio } from 'antd';
import { isNil } from 'lodash-es';
import { TodoSubType } from 'views/Conversation/Sider/ToDoBundle/FormItem';
import { TicketSetting } from '../TicketSetting';
import { useTickTypeSource } from 'hooks/business/chat/useTickTypeSource';

export type SubTypes = [subType?: string, subType2?: string, subType3?: string];

interface NewSelectTypeProps {
  storeId: string;
  taskId: number;
  typeSource: TypeSource;
  platform: General.PlatformUpperCase;
  type?: Todo.Type;
  onChange: (type: Todo.Type) => void;
  subType: SubTypes;
  onChangeSubType: (subType: SubTypes) => void;
}

export const NewSelectType = (props: NewSelectTypeProps) => {
  const { storeId, taskId, typeSource, platform, type, onChange, subType, onChangeSubType } = props;

  const { t } = useTranslate();
  const { localTypeSource, refresh } = useTickTypeSource({
    taskId,
    remoteTypeSource: typeSource,
    platform,
  });

  const openedTypeSource = useMemo(() => {
    return localTypeSource.filter((e) => e.localEnable);
  }, [localTypeSource]);

  const options = useMemo(() => {
    return openedTypeSource.map((e) => ({
      label: e.typeLabel,
      value: e.type,
    }));
  }, [openedTypeSource]);

  const subTypeOptions = useMemo(() => {
    return openedTypeSource.find((e) => e.type === type)?.subTypeTrees || [];
  }, [openedTypeSource, type]);

  const hasSubType = subTypeOptions.length > 0;

  const handleChangeType = (value: Todo.Type) => {
    onChange(value);
    onChangeSubType([]);
  };

  useEffect(() => {
    if (isNil(type) && options.length > 0) {
      onChange(options[0].value);
    }
  }, [type, onChange, options]);

  return (
    <>
      <Panel
        title={t('choose_solution')}
        titleExtra={
          <TicketSetting
            storeId={storeId}
            taskId={taskId}
            typeSource={localTypeSource}
            onRefresh={refresh}
          />
        }
      >
        <Radio.Group
          className="w-full"
          value={type}
          onChange={(e) => handleChangeType(e.target.value)}
        >
          <div className="w-full grid grid-cols-2 gap-x-2 gap-y-3">
            {options.map((each) => (
              <Radio key={each.value} value={each.value}>
                {each.label}
              </Radio>
            ))}
          </div>
        </Radio.Group>
      </Panel>
      {hasSubType && (
        <Panel title={t('st_3')}>
          <TodoSubType
            className="!w-full"
            dataSource={subTypeOptions}
            value={subType.filter((e) => e !== undefined)}
            onChange={(value) => {
              onChangeSubType(value as SubTypes);
            }}
          />
        </Panel>
      )}
    </>
  );
};
